import { ReadonlyRepositoryListService } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { routeParamAsNumber } from '@softline/application';
import { SalesPriceRepository } from '../repositories/sales-price.repository';
import { SalesPrice } from '../types/sales-price';
import { SalesPriceQuery } from '../types/sales-price.query';
import { SalesPriceQueryService } from './sales-price-query.service';

@Injectable()
export class SalesPriceService extends ReadonlyRepositoryListService<
  SalesPrice,
  SalesPrice[],
  SalesPriceQuery
> {
  private readonly queryService = inject(SalesPriceQueryService);

  productId = routeParamAsNumber('id');
  override params = computed(() => {
    return {
      productId: this.productId() ?? 0,
      showAll: this.queryService.showAll(),
    };
  });

  constructor() {
    super(inject(SalesPriceRepository));
  }

  protected override getItems(result: SalesPrice[] | null | undefined): SalesPrice[] {
    return result as SalesPrice[];
  }
}
